export default __webpack_public_path__ + "static/google-play-c67026421afa841e0d283f17004965ac.png";